import { render, staticRenderFns } from "./PregnantTotalGrowpropertiesModal.vue?vue&type=template&id=766e14f6"
import script from "./PregnantTotalGrowpropertiesModal.vue?vue&type=script&lang=js"
export * from "./PregnantTotalGrowpropertiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports